module.exports = __webpack_public_path__ + "img/slider_7.ebf76323.jpg";